import MyTable from "../../Component/MyTable"
import AddIcon from '@mui/icons-material/Add';
import { MenuItem, ListItemIcon, ListItemText, Alert, Paper, Toolbar, Typography, Button, Stack, Snackbar, Backdrop, ButtonGroup, FormControl,InputLabel,Select, FormControlLabel, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult, getUserSession, sessionSet,} from "../../Utils/Common";
import apis from "../../api";
import { RightDrawer } from "../../Component/MuiEx";
import {  useParams } from "react-router";
import DownMenuItem from "../../Component/DownMenuItem"

import { getItemsFromObjects, loadCourseCategories } from "../../Component/DataLoader";
import { CourseLoader } from "../fragement/CourseSelector";
import EditCoursePackage from "./fragement/EditCoursePackage";

const CoursePackages = () => {
    const params = useParams()
    const [loading, setLoading] = useState(false)
    const [rightDrawer, setRightDrawer] = useState()
    const [hintMsg, setHintMsg] = useState()
    const [datas, setDatas] = useState([])    
    const [categories,setCategories] = useState()
    const [courses,setCourses] = useState()
    const [curClass,setCurClass] = useState(params.cid>0?params.cid:0)
    const [curStatus,setCurStatus] = useState(1)
    const [error, setError] = useState()
    const [autoCloseRightDraw, setAutoCloseRightDraw] = useState(true)
    getUserSession(apis)
    
    const handleHintClose = () => {
        setHintMsg()
    }
    const loadDatas = (category_id,status) => {
        setLoading(true)
        apis.coursepackageGet(category_id,status).then(ret => {
            apiResult(ret, (r) => {
                setDatas(r)
            }, setError)
            setLoading()
        })
    }
    let initPage = false
    useEffect(() => {
        if (initPage) return
        initPage = true        
        loadCourseCategories(apis,(data)=>setCategories(data),setError)
        CourseLoader((data)=>setCourses(data),apis,false)
        loadDatas(curClass,curStatus)
    }, [])

    const handleAfterEdit = (idx, data, err, errs) => {
        apis.coursepackagePost(data).then(ret => {
            apiResult(ret, (id) => {
                sessionSet('course_packages', null)
                setAutoCloseRightDraw(true)
                setRightDrawer(false)
                loadDatas(curClass, curStatus)
            }, err, errs)
        })
    }
    const handleRightDrawer = () => {
        if (autoCloseRightDraw)
            setRightDrawer(false)
    }

    const handleAdd = () => {
        setAutoCloseRightDraw(false)
        setRightDrawer(<EditCoursePackage data={{ id: 0 }} onSubmit={(data, err, errs) => { handleAfterEdit(-1, data, err, errs) }} onClose={() => { setRightDrawer(false) }} />)
    }
    const handleDelete = (idx, item) => {
        apis.coursepackageDelete(item.id).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 0
                setDatas(cc)
            }, setError)
        })
    }
    const handleEnable = (idx, item) => {
        apis.coursepackagePut({ id: item.id, status: 1 }).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc[idx].status = 1
                setDatas(cc)
            }, setError)
        })
    }
    const handleView = (idx, item) => {
        window.open('/member/course/0/' + item.id)
    }
    const handleCategory = (id)=>{
        
    }
    const handleCourse = (id)=>{
        
    }
    const TableHeader = [
        { name: 'id', showName: 'ID' },
        { name: 'category', showName: 'Category',func:(v,idx,item)=>{            
            let category = getItemsFromObjects(categories,item.category_id)
            return <Typography onClick={()=>handleCategory(category?category.id:0)} sx={{cursor:'pointer'}}>{category && (category.code+" | "+category.name)}</Typography>                                        
        } },
        { name: 'course', showName: 'Course',func:(v,idx,item)=>{            
            if(courses) {
                let course = getItemsFromObjects(courses,item.course_id)
                return <Typography onClick={()=>handleCourse(course?course.id:0)} sx={{cursor:'pointer'}}>{course && (course.code+" | "+course.name)}</Typography>                                        
            }else {
                return <></>
            }
        } },
        { name: 'billtype', showName: 'Billing Type',func:(v,idx,item)=>{
            return ["Lesson","Time"][v]
        } },        
        { name: "minutes",showName:"Minutes/lesson",func:(v,idx,item)=>{
            return item.billtype == 0?((v/60).toFixed(1)+" hours/lesson"):""
        }},
        { name: "price",showName:"Unit Price",func:(v,idx,item)=>{
            return "$"+(item.billtype == 0?(v+"/lesson"):(v+"/hour"))
        }},
        { name: 'tax', showName: 'Tax',func:(v,idx,item)=>{
            return Number(v)*100+"%"
        } },
        { name: 'description', showName: 'Description'},
        {
            name: 'option', showName: 'Options', func: (v, idx, item) => {
                return <ButtonGroup size="small" variant="contained" aria-label="outlined primary button group">                    
                    <Button variant={item.status == 0 ? "outlined" : "contained"} onClick={() => item.status != 0 ? handleDelete(idx, item) : handleEnable(idx, item)}>{item.status == 0 ? 'Disable' : 'Enable'}</Button>
                    <Button variant="outlined" onClick={() => handleView(idx, item)}>Members</Button>
                </ButtonGroup>
            }
        },
    ]
    const OptionButton = [
        { text: "Add", icon: <AddIcon fontSize="small" />, onClick: handleAdd },
    ]
    return (
        <>
            <Backdrop open={loading} />
            {error && <Alert severity={"warning"} sx={{ width: '100%', marginTop: "5px", mb: 2 }} onClose={() => setError()}>{error}</Alert>}
            <Paper sx={{ marginBottom: 2 }}>
                <Toolbar style={{ paddingLeft: 2 }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }}>
                        {OptionButton.map((item, index) => {
                            return item.subItems ? <DownMenuItem key={index} icon={item.icon} onClick={item.onClick} items={item.subItems} text={item.text} /> :
                                <MenuItem key={index} onClick={item.onClick}>
                                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}<ListItemText>{item.text}</ListItemText>
                                </MenuItem>
                        })}
                    </Stack>
                    <Typography sx={{ flex: '1 1 50%' }} variant="h6" component="div" ></Typography>
                    <FormControl sx={{width:250,mr:1}}>
                        <FormControlLabel control={<Switch defaultChecked onChange={(e)=>{setCurStatus(e.target.checked?1:0);loadDatas(curClass,e.target.checked?1:0)}}/>} label="Active Class" />
                    </FormControl>                    
                    <FormControl sx={{width:250,mr:1}}>
                        <InputLabel id="select-course">{"Select Course Category"}</InputLabel>
                        <Select labelId="select-course"
                            defaultValue={curClass}
                            id="category_id" onChange={(e) => { setCurClass(e.target.value);loadDatas(e.target.value,curStatus);}}
                            label={"Select Course Category"}>
                            {categories && [...categories,{id:0,name:"All"}].map((p, idx) => {
                                return <MenuItem key={idx} value={p.id}>{p.name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>                    
                </Toolbar>
            </Paper>
            {datas.length == 0 && <Alert severity={"info"}>Ops! There is not any data</Alert>}
            {datas.length > 0 && <MyTable
                height={650}
                rows={datas}
                totalRow={datas.length}
                headers={TableHeader}
                checkbox={false}
                rowsPerPage={datas.length}
            />}
            {hintMsg && <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={hintMsg ? true : false} autoHideDuration={3000} onClose={handleHintClose}>
                <Alert onClose={handleHintClose} severity="success" sx={{ width: '100%' }}>{hintMsg}</Alert>
            </Snackbar>}
            <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
                {rightDrawer}
            </RightDrawer>
        </>

    )
}
export default CoursePackages